import { useRef } from "react";
import style from "./AppSearchPage.module.scss";
import { useSelector } from "react-redux";
import { selectDrugSearchSuggestions } from "../../../features/enhancedSearch";
import classNames from "classnames";
import { saveRecentSearches } from "../../../features/enhancedSearch/recentSearchService";
import SearchResults from "../HeadSearch/SearchResults";
import PropTypes from "prop-types";

export const AppDrugSearchTabs = ({ push, searchValue }) => {
  const dropdownMobileRef = useRef(null);
  const suggestionsSelector = useSelector(selectDrugSearchSuggestions);
  const showSuggestion = searchValue.trim().length >= 3;
  const suggestionItemClick = (item) => {
    try {
      saveRecentSearches("drugSearches", {
        searchText: item.suggestion,
        url: item.url,
      });
      push(item.url);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      className={classNames("size-14", style.searchLinks)}
      data-testid="search-tabs-page"
    >
      {showSuggestion && (
        <div className={style.searchSuggestions}>
          <SearchResults
            ref={dropdownMobileRef}
            items={suggestionsSelector}
            handleSelect={suggestionItemClick}
            type="search"
            resultStyle={style}
            showSuggestion={showSuggestion}
            showSavedOrRecent={false}
          />
        </div>
      )}
    </div>
  );
};

AppDrugSearchTabs.propTypes = {
  push: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
};
